/**
 * Client-side timebase shared by the sim loop, HUD/recall formatting and the
 * snapshot-rate mapping.
 *
 * This must match the Rust core (`core/src/lib.rs::TICK_RATE`) and the server's
 * advertised `tickRate`. `main.ts` asserts the WASM value at startup; the
 * welcome handler rejects a server advertising a different rate.
 */
export const TICK_RATE = 125;
/** Fixed simulation step in milliseconds (8 ms at 125 Hz). */
export const TICK_MS = 1000 / TICK_RATE;
/** Fixed simulation step in seconds. */
export const TICK_DT = 1 / TICK_RATE;

/** Convert a tick count to milliseconds (fractional). */
export function ticksToMs(ticks: number): number {
  return (ticks * 1000) / TICK_RATE;
}

